class Animation {
	constructor(config) {
		this.config = Object.assign({
			scope: '.animation-scope',
			hover: '.animation-hover',
			target: '.animation-target',
			activeClass: 'animation-active'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initEventListeners();
	}

	initEventListeners() {
		this.$scope.find(this.config.hover).on({
			mouseenter: (e) => this.applyAnimationOnTarget(e),
			mouseleave: (e) => this.removeAnimationFromTarget(e)
		});
	}

	applyAnimationOnTarget(e) {
		let $scope = $(e.currentTarget).closest(this.config.scope);
		$scope.find(this.config.target).addClass(this.config.activeClass);
	}

	removeAnimationFromTarget(e) {
		let $scope = $(e.currentTarget).closest(this.config.scope);
		$scope.find(this.config.target).removeClass(this.config.activeClass);
	}
}

export default new Animation;